import React from 'react';
import Search from './Search';
import MenuItems from './MenuItems';
import * as App from 'modules/app/App';

class Sidebar extends React.Component {
    render() {
            
        return (
            <aside className="main-sidebar">
                <section className="sidebar">
                    <div className="welcome">
                        Welcome {App.context().userName}!<br />
                    </div>
                    <Search />
                    <MenuItems />
                </section>
            </aside>)
    }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/layouts/main/sidebar/Sidebar.js